import { render, staticRenderFns } from "./InvoiceDetailsIssued.vue?vue&type=template&id=23e28ce9&scoped=true"
import script from "./InvoiceDetailsIssued.vue?vue&type=script&lang=js"
export * from "./InvoiceDetailsIssued.vue?vue&type=script&lang=js"
import style0 from "./InvoiceDetailsIssued.vue?vue&type=style&index=0&id=23e28ce9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e28ce9",
  null
  
)

export default component.exports